import script from "./show-recipes-for-ingredient.vue?vue&type=script&setup=true&lang=js"
export * from "./show-recipes-for-ingredient.vue?vue&type=script&setup=true&lang=js"

import "./show-recipes-for-ingredient.vue?vue&type=style&index=0&id=6c859a1e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c859a1e"]])

export default __exports__